import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import SessionService from '../../services/session';
import { Session } from '../../models/session/types';

/**
 * Base query key for the current Experience session (scoped by program id).
 */
export const SESSION_QUERY_KEY = 'session';

/**
 * Fetch the current session fresh from mojo (uncached, session-aware) so the
 * SP-initiated SLO decision at Sign Out reflects THIS session's login method,
 * rather than a `session_is_sso` value cached at program scope on the server.
 *
 * @param programId - The current program id (keys the cache per program)
 * @param options - Optional React Query options
 * @returns Query result with the current session, or null if none is returned
 */
export const useSessionQuery = (
  programId: string,
  options?: Omit<
    UseQueryOptions<Session | null, Error, Session | null, string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<Session | null, Error, Session | null, string[]>({
    queryKey: [SESSION_QUERY_KEY, programId],
    queryFn: async () => {
      const response = await new SessionService().fetch();
      return response.data.sessions?.[0] ?? null;
    },
    keepPreviousData: true,
    ...options,
  });
};
